import React, { useContext, useState } from 'react';

import { useAggregatedState } from '../../../../helpers';

export const PageContext = React.createContext(null);

const { Provider } = PageContext;
export const PageProvider = ({ ...props }) => {
    const [pageIsReady, setPageIsReady] = useState(true);
    const [state, setState] = useAggregatedState({});
    
    return (
        <Provider value={{
            state,
            pageIsReady,
            setPageIsReady
        }}>
            {props.children}
        </Provider>
    );
}